export const LogTags = () => {
    let storage = {};
    function addTag(tag, value) {
        storage[tag] = value;
    }
    function getTags() {
        return Object.assign({}, storage);
    }
    function setTags(tags) {
        storage = tags;
    }
    function updateTags(tags) {
        storage = Object.assign(Object.assign({}, storage), tags);
    }
    function clearTags() {
        storage = {};
    }
    function toString() {
        return JSON.stringify(storage);
    }
    return {
        addTag,
        clearTags,
        setTags,
        toString,
        updateTags,
        getTags,
    };
};
